module.exports = __webpack_public_path__ + "img/frame (136).07095484.jpg";